// Response tree data parsed from data/responses.csv
// Each node: { id, parentId, label, isLeaf, position }
// Note: top position is reserved for "Back" on all response screens.

const nodes = [
  // Root nodes (home screen — all 4 positions used)
  { id: 1, parentId: null, label: 'Respond', isLeaf: false, position: 'top' },
  { id: 2, parentId: null, label: 'Need', isLeaf: false, position: 'left' },
  { id: 3, parentId: null, label: 'Ask', isLeaf: false, position: 'right' },
  { id: 4, parentId: null, label: 'Pain', isLeaf: false, position: 'bottom' },

  // Children of Respond (1)
  { id: 5, parentId: 1, label: 'Yes', isLeaf: true, position: 'right' },
  { id: 6, parentId: 1, label: 'No', isLeaf: true, position: 'left' },
  { id: 8, parentId: 1, label: 'Repeat\nThat', isLeaf: true, position: 'bottom' },

  // Children of Need (2)
  { id: 10, parentId: 2, label: 'Bathroom', isLeaf: true, position: 'left' },
  { id: 11, parentId: 2, label: 'Rest', isLeaf: true, position: 'right' },
  { id: 12, parentId: 2, label: 'Help', isLeaf: true, position: 'bottom' },

  // Children of Ask (3)
  { id: 14, parentId: 3, label: 'Get My\nPhone', isLeaf: true, isFreeResponse: true, position: 'right' },
  { id: 15, parentId: 3, label: 'Get Nurse/\nDoctor', isLeaf: true, position: 'left' },
  { id: 16, parentId: 3, label: 'Turn\non TV', isLeaf: true, isFreeResponse: true, position: 'bottom' },

  // Children of Pain (4)
  { id: 18, parentId: 4, label: 'Not Well', isLeaf: false, position: 'right' },
  { id: 19, parentId: 4, label: 'Upset', isLeaf: false, position: 'left' },
  { id: 20, parentId: 4, label: 'Uncomfortable', isLeaf: false, position: 'bottom' },

  // Children of Not Well (18)
  { id: 34, parentId: 18, label: 'Dizzy', isLeaf: false, position: 'right' },
  { id: 35, parentId: 18, label: 'Tired', isLeaf: false, position: 'left' },
  { id: 36, parentId: 18, label: 'Sore', isLeaf: false, position: 'bottom' },

  // Children of Upset (19)
  { id: 38, parentId: 19, label: 'Sad', isLeaf: true, position: 'right' },
  { id: 39, parentId: 19, label: 'Frustrated', isLeaf: true, position: 'left' },
  { id: 40, parentId: 19, label: 'Confused', isLeaf: true, position: 'bottom' },

  // Children of Uncomfortable (20)
  { id: 42, parentId: 20, label: 'Physical', isLeaf: false, position: 'bottom' },
  { id: 43, parentId: 20, label: 'Practical', isLeaf: false, position: 'left' },
  { id: 44, parentId: 20, label: 'Medical', isLeaf: false, position: 'right' },

  // Children of Dizzy (34)
  { id: 66, parentId: 34, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 67, parentId: 34, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 68, parentId: 34, label: 'Unbearable', isLeaf: true, position: 'bottom' },

  // Children of Tired (35)
  { id: 70, parentId: 35, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 71, parentId: 35, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 72, parentId: 35, label: 'Unbearable', isLeaf: true, position: 'bottom' },

  // Children of Sore (36)
  { id: 74, parentId: 36, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 75, parentId: 36, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 76, parentId: 36, label: 'Unbearable', isLeaf: true, position: 'bottom' },

  // Children of Physical (42)
  { id: 82, parentId: 42, label: 'Itchy', isLeaf: false, position: 'left' },
  { id: 83, parentId: 42, label: 'Need to\nbe Moved', isLeaf: false, position: 'right' },
  { id: 84, parentId: 42, label: 'Sore', isLeaf: false, position: 'bottom' },

  // Children of Practical (43)
  { id: 86, parentId: 43, label: 'Need Pillow\nAdjusted', isLeaf: true, position: 'left' },
  { id: 87, parentId: 43, label: 'Need\nSuction', isLeaf: true, position: 'right' },
  { id: 88, parentId: 43, label: 'Need Glasses/\nDevice', isLeaf: true, position: 'bottom' },

  // Children of Medical (44)
  { id: 90, parentId: 44, label: 'Equipment\nIssue', isLeaf: true, position: 'left' },
  { id: 91, parentId: 44, label: 'Need Doctor\nCheck', isLeaf: true, position: 'right' },
  { id: 92, parentId: 44, label: 'Need Nurse\nCheck', isLeaf: true, position: 'bottom' },

  // Children of Itchy (82)
  { id: 114, parentId: 82, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 115, parentId: 82, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 116, parentId: 82, label: 'Unbearable', isLeaf: true, position: 'bottom' },

  // Children of Need to be Moved (83)
  { id: 118, parentId: 83, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 119, parentId: 83, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 120, parentId: 83, label: 'Unbearable', isLeaf: true, position: 'bottom' },

  // Children of Sore/Physical (84)
  { id: 122, parentId: 84, label: 'Moderate', isLeaf: true, position: 'right' },
  { id: 123, parentId: 84, label: 'Severe', isLeaf: true, position: 'left' },
  { id: 124, parentId: 84, label: 'Unbearable', isLeaf: true, position: 'bottom' },
];

const nodeMap = new Map(nodes.map(n => [n.id, n]));

const POSITION_ORDER = { top: 0, left: 1, right: 2, bottom: 3 };

export function getRootNodes() {
  return nodes
    .filter(n => n.parentId === null)
    .sort((a, b) => POSITION_ORDER[a.position] - POSITION_ORDER[b.position]);
}

export function getChildren(parentId) {
  return nodes
    .filter(n => n.parentId === parentId)
    .sort((a, b) => POSITION_ORDER[a.position] - POSITION_ORDER[b.position]);
}

export function getNode(id) {
  return nodeMap.get(id) || null;
}
